import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { ConceptForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { concept, onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Concepts", link: "/concept" },
                { name: "Edit", link: "" },
                { name: concept?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Concept" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Concept Update"}
                        bordered={true}
                    >
                        {concept && (
                            <ConceptForm
                                concept={concept}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
